import facepaint from "facepaint";
import { variables } from "../themes";

const breakpoints = Object.values(variables.breakpoints);

export default facepaint(
  breakpoints.map((bp) => `@media (min-width: ${bp}px)`)
);
